<template>
  <div
    :class="{
      'block-list-content': true,
      twoline: resource.length >= 12,
    }"
  >
    <ul class="innerBlock">
      <li
        class="block-list-item"
        v-for="(list, index) in resource"
        :key="index"
        v-report="{
          module: 'lecture_feeds',
          data: {
            ssid: list.seasonId
          }
        }"
        v-reportShow="{
          module: 'lecture_feeds',
          data: {
            ssid: list.seasonId
          }
        }"
      >
        <a
          :href="`${list.link}?spm_id_from=${spmidfrom}` | hostAdapt | csourceTransmit"
          target="_blank"
          v-href
          @click="clickSortLesson(title, list.seasonId)"
        >
          <div class="block-list-item-img">
            <BiliImg
              :src="list.cover"
              :width="206"
              :height="116"
              cut
              class="block-list-lazyImg"
            />

            <!-- <div class = 'block-list-item-label' v-if = 'list.status_label'>{{ list.status_label }}</div> -->

            <div class="block-list-item-info-mask"></div>
            <div class="block-list-item-info">
              <div class="block-list-item-info-player">
                <img
                  src="../assets/images/classroom/player.png"
                  class="block-list-item-info-player--img"
                />
                <span>{{ list.stat && list.stat.view | isThousand }}</span>
              </div>

              <p>{{ "共" + list.ep_count + "课时" }}</p>
            </div>
          </div>

          <p class="block-list-item-title ell">{{ list.title }}</p>

          <p class="block-list-item-desc ell">{{ list.subtitle }}</p>
          <!-- 已购买 -->
          <p
            class="block-list-item-price buy"
            v-if="list.user_status && list.user_status.payed === 1"
          >
            已拥有
          </p>

          <p class="block-list-item-price" v-else>
            <span
              :class="{
                'price-pre': list.coupon_price_format,
              }"
              >{{
                list.coupon_price_format_show || list.price_format_show
              }}</span
            >
            <span
              class="block-list-item-price line"
              v-if="list.coupon_price_format_show"
              >|</span
            >
            <del
              class="block-list-item-price origin"
              v-if="list.coupon_price_format_show"
              >{{ list.price_format_show }}</del
            >
          </p>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import BiliImg from 'g-public/components/CommonLazyImg'

export default {
  components: {
    BiliImg,
  },
  props: {
    spmidfrom: {
      required: true,
      type: String,
    },
    resource: {
      type: Array,
      default: () => [],
    },
    transform: {
      type: Boolean,
      default: false,
    },
    resourceId: {
      type: Number | String,
      // required: true
    },
    row: {
      type: String,
    },
    title: {
      type: String,
    },
  },
  data() {
    return {}
  },
  computed: {
    twoRow() {
      if (this.transform) {
        return this.resource.length >= 6
      } else if (this.row) {
        return false
      } else {
        return this.resource.length > 12
      }
    },

    sixSolution() {
      return this.transform && this.resource.length === 6
    },
  },
  created() {},
  mounted() {},
  methods: {
    clickSortLesson(title, seasonid) {
    },
  },
}
</script>

<style lang="less">
@import url("../styles/list-slider.less");
</style>

<style lang="less" scoped>
.block-list-content {
  overflow: hidden;
  .innerBlock {
    width: 1312px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  &.twoline {
    .block-list-item:nth-of-type(1) {
      margin-bottom: 20px !important;
    }
  }
}

.block-list-item-info-player {
  display: flex;
  align-items: center;
}

.block-list-item-info-player--img {
  margin-right: 4px;
  width: 16px;
  height: 16px;
}

.block-list-item {
  margin-right: 10px;
  cursor: pointer;
  &:last-child {
    margin-right: 0;
  }
}

.block-list-item-img {
  width: 206px;
  height: 116px;
  position: relative;
  border-radius: 4px;
}

.block-list-item-title {
  width: 206px;
  /* max-height: 40px;
    overflow: hidden; */
  font-size: 14px;
  color: #212121;
  margin-top: 10px;
  margin-right: 0;
  font-weight: 500;
  &:hover {
    color: #0ba395;
  }
}

.block-list-item-desc {
  color: #999;
  font-size: 12px;
  line-height: 16px;
  margin: 8px 0;
  width: 206px;
}

.block-list-item-label {
  position: absolute;
  right: 8px;
  top: 8px;
  z-index: 99;
  text-align: center;
  /* width: 50px; */
  padding: 0 10px;
  height: 22px;
  line-height: 22px;
  color: #fff;
  background: #0ba395;
  border-radius: 2px;
  font-size: 12px;
}

.block-list-item-price {
  color: #0ba395;
  line-height: 20px;

  &.buy {
    color: #999999;
  }

  &.line {
    color: #d8d8d8;
  }

  &.origin {
    color: #999999;
  }
}

.block-list-item-info {
  position: absolute;
  width: 100%;
  bottom: 6px;
  left: 0;
  padding: 0 8px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  color: #fff;
  font-size: 12px;
}

.block-list-item-first-box {
  display: flex;
}

.block-list-item-first-content {
  background: rgba(11, 163, 149, 0.05);
  flex: 1;
  padding: 20px;
  box-sizing: border-box;
}

.block-list-item-playInfo-first {
  display: flex;
  color: #999;
  margin-top: 12px;
}

.block-list-item-playInfo-first-count {
  margin-right: 20px;
}

.block-list-item-price-first {
  margin-top: 50px;
}

.block-list-item-info-mask {
  position: absolute;
  width: 100%;
  height: 58px;
  bottom: 0;
  left: 0;
  background-image: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.6) 100%
  );
  border-radius: 0 0 2px 2px;
}

.price-pre {
  font-weight: 500;
}

@media screen and (max-width: 1438px) {
  .block-list-content {
    &.transform {
      .block-list-item:nth-child(1) {
        .block-list-item-title {
          width: 224px;
        }
      }
    }

    &.sixSolution {
      flex-direction: row !important;
    }
  }
}
</style>
